import { usePageCapabilities } from "../../Shared/usePageCapabilities";
import { useLandingPageActions } from "./LandingPageContext";

export function useLandingPageCapabilities() {
  const {
    openInvitationRequestWizard
  } = useLandingPageActions();

  usePageCapabilities(
    {},
    [
      {
        id: 'open_invitation_request_wizard',
        label: 'Request an Invitation',
        onClick: openInvitationRequestWizard,
        capability: 'showRequestInvitationNavigation',
      },
    ]
  );
}
